import axios from 'axios';

import type { PostApiV1BonusPointsBulkIssueData, PostApiV1BonusPointsIssueData } from '~/api/generated';

type BonusPointsAward = NonNullable<PostApiV1BonusPointsIssueData['body']>;
type BulkBonusPointsAward = NonNullable<PostApiV1BonusPointsBulkIssueData['body']>;

const BASE_PATH = '/api/v1/bonus_points';

export async function issueBonusPoints(award: BonusPointsAward): Promise<void> {
  await axios.post(`${BASE_PATH}/issue`, award);
}

export async function bulkIssueBonusPoints(award: BulkBonusPointsAward): Promise<void> {
  await axios.post(`${BASE_PATH}/bulk_issue`, award);
}
